<template>
    <div>
        <el-button type="primary" :disabled="disabled" @click="formDialogVisible=true">{{fName+'协议'}}</el-button>
        <el-dialog :title="fName+'协议编辑'" width="1000px" :visible="formDialogVisible" :modal="false"
                   :close-on-click-modal="false" @close="closeDialog">
            <el-form label-width="120px">
                <el-form-item label="协议标题：">
                    <el-input placeholder="请输入协议标题" maxlength="500" v-model="formData.name"
                              style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item label="表单说明：" style="margin-top: 20px">
                    <Editor v-model="formData.content" class="editor" style="height: 500px"></Editor>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width: 100%;text-align: center">
                    <el-button @click="formDialogVisible=false">取消</el-button>
                    <el-button type="danger" @click="handleSave()">保存</el-button>
                </div>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import Editor from 'components/editor';

    export default {
        name: "AgreementData",
        components: {
            Editor
        },
        props: ['value', 'fName','disabled'],
        data() {
            return {
                formDialogVisible: false,
                formData: this.value ? this.value : {name: "", content: ""},
                formDataRules: {},
            }
        },
        watch: {
            value: {
                handler(newName, oldName) {
                    this.formData = newName;
                },
                deep: true
            },
            formData: {
                handler(newName, oldName) {
                    this.$emit('change', newName);
                    this.$emit('input', newName);
                },
                deep: true
            }
        },
        methods: {
            handleSave() {
                this.$emit('change', this.formData);
                this.formDialogVisible = false;
            },
            closeDialog() {
                this.formDialogVisible = false;
            }
        }
    }
</script>

<style scoped>

</style>